import { Host, h } from '@stencil/core';
import classNames from '../../../utils/classnames.utils';
export class AibaLabel {
  constructor() {
    this.styles = undefined;
    this.classes = undefined;
    this.tag = undefined;
    this._id = undefined;
    this.text = undefined;
    this.animationType = undefined;
    this.variant = undefined;
    this.setInnerHTML = false;
    this.innerHTML = undefined;
    this.noTranslate = false;
    this.isMandatory = undefined;
    this.arialabel = undefined;
  }
  getCssClassMap() {
    const name = 'label-wrapper';
    const prefix = `${name}--${this.tag}`;
    return classNames(prefix, this.animationType && `${name}--animation-${this.animationType}`, this.variant && `${prefix}-${this.variant}`, this.classes && `${this.classes}`);
  }
  render() {
    const Tag = `${this.tag}`;
    return (h(Host, Object.assign({ id: this._id ? this._id : '' }, (this.noTranslate && { translate: 'no' })), this.styles && h("style", null, this.styles), !this.setInnerHTML ? (h(Tag, { ariaLabel: this.arialabel, class: this.getCssClassMap() }, this.text, this.isMandatory && h("span", { class: `label-wrapper--${this.tag}${this.variant ? '-' + this.variant : ''}__text-mandatory` }, "*"))) : (h(Tag, { ariaLabel: this.arialabel, class: this.getCssClassMap(), innerHTML: this.innerHTML ? this.innerHTML : this.text })), h("slot", null)));
  }
  static get is() { return "aiba-label"; }
  static get originalStyleUrls() {
    return {
      "$": ["aiba-label.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["aiba-label.css"]
    };
  }
  static get properties() {
    return {
      "styles": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "styles",
        "reflect": false
      },
      "classes": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "classes",
        "reflect": false
      },
      "tag": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "tag",
        "reflect": false
      },
      "_id": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "_id",
        "reflect": false
      },
      "text": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "text",
        "reflect": false
      },
      "animationType": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "'fadeIn' | 'colorChange'",
          "resolved": "\"colorChange\" | \"fadeIn\"",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "animation-type",
        "reflect": false
      },
      "variant": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "'primary' | 'secondary'",
          "resolved": "\"primary\" | \"secondary\"",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "variant",
        "reflect": false
      },
      "setInnerHTML": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "set-inner-h-t-m-l",
        "reflect": false,
        "defaultValue": "false"
      },
      "innerHTML": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "inner-h-t-m-l",
        "reflect": false
      },
      "noTranslate": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "no-translate",
        "reflect": false,
        "defaultValue": "false"
      },
      "isMandatory": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "is-mandatory",
        "reflect": false
      },
      "arialabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "arialabel",
        "reflect": false
      }
    };
  }
}
//# sourceMappingURL=aiba-label.js.map
